/* eslint-disable prettier/prettier */
import { api } from "./ConfiguracionBancoApi"

export const ReporteProdubancoApi =
{
    getReporteProdubanco1()
    {
        return api.get("reporteprodubanco/registros")
    },
    // eslint-disable-next-line object-shorthand
    getReporteProdubanco2:function()
    {
        return api.get("reporteprodubanco/reportes-por-masmenos")
    },
    getReporteProdubanco()
    {
        return api.get("reporteprodubanco")
    },
    getReporteProdubancoId(id: number)
    {
        return api.get(`reporteprodubanco/${id}`)
    },
    createReporteProdubanco(data: any){
        return api.post("reporteprodubanco", data);
    },
    updateReporteProdubanco(id: number, data: any){
        return api.put(`reporteprodubanco/${id}`, data);
    },
    deleteReporteProdubanco(id: number){
        return api.delete(`reporteprodubanco/${id}`);
    }
}